import Vue from "vue";
import VueRouter from "vue-router";
import { coreRouter } from "./routes/core";
Vue.use(VueRouter);

const routes = [
 ...coreRouter,
 {
  path: "/:pathMatch(.*)*", // 匹配所有未定义的路径
  name: "NotFound",
  component: () => import("@/components/not-found/index.vue"),
},
];
const router = new VueRouter({
  mode: "history",
  base:process.env.VUE_APP_BASE_ROUTE,
  routes,
});
router.beforeEach((to, from, next) => {
  // 如果设置了 meta.title，就更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router;
